import { CallStatus } from '@src/types/calls';
import { useMemo } from 'react';

export type CallStatusFlags = {
  isCallWaitingAgent: boolean;
  isCallWaitingAnswer: boolean;
  isCallTerminated: boolean;
  isCallMissed: boolean;
  isCallFailed: boolean;
  isCallRejected: boolean;
  isCallOngoing: boolean;
};

export const callStatusFlags = (callStatus?: CallStatus): CallStatusFlags => ({
  isCallWaitingAgent: callStatus === CallStatus.WAITING_AGENT,
  isCallWaitingAnswer: callStatus === CallStatus.WAITING_ANSWER,
  isCallTerminated: callStatus === CallStatus.TERMINATED,
  isCallMissed: callStatus === CallStatus.MISSED,
  isCallFailed: callStatus === CallStatus.FAILED,
  isCallRejected: callStatus === CallStatus.REJECTED,
  isCallOngoing: callStatus === CallStatus.ONGOING,
});

const useCallStatusFlags = (callStatus?: CallStatus): CallStatusFlags =>
  useMemo(() => callStatusFlags(callStatus), [callStatus]);

export default useCallStatusFlags;
